/** Normalize phone for `tel:` (digits and + only). */
export function phoneTelHref(phone: string | undefined | null): string | null {
  const raw = String(phone ?? '').trim();
  if (!raw) return null;
  const normalized = raw.replace(/[^\d+]/g, '');
  if (!normalized.replace(/\+/g, '')) return null;
  return `tel:${normalized}`;
}

export function emailMailtoHref(email: string | undefined | null): string | null {
  const raw = String(email ?? '').trim();
  if (!raw || !raw.includes('@')) return null;
  return `mailto:${raw}`;
}
